module.exports = __webpack_public_path__ + "assets/GoldLambda.a779aef1ee592bb6af88efb707e43468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldLambda.png
// module id = 765
// module chunks = 0